<template>
  <div id="chart">
    <apexchart
      type="line"
      :height="chartHeight"
      :options="chartOptions"
      :series="chartSeries"
    ></apexchart>
  </div>
</template>
<style>
.apexcharts-toolbar {
  z-index: 2 !important;
}
</style>
<script>
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    apexchart: VueApexCharts
  },
  props: ["height", "xaxis", "series", "yaxis"],
  computed: {
    chartHeight() {
      if (!this.height) {
        return "400px";
      } else {
        return this.height;
      }
    },
    chartSeries() {
      if (!this.series || !Array.isArray(this.series)) {
        return [];
      } else {
        return this.series;
      }
    },
    chartOptions() {
      let x = null;
      if (!this.xaxis || !Array.isArray(this.xaxis)) {
        x = [];
      } else {
        x = this.xaxis;
      }
      let y = {
        title: {
          text: "Courses"
        }
      };
      if (this.yaxis && this.yaxis.title && this.yaxis.title.text) {
        y = this.yaxis;
      }
      if (Array.isArray(this.yaxis)) {
        y = this.yaxis;
      }
      return {
        markers: {
          size: 4
        },
        chart: {
          type: "line",
          zoom: {
            enabled: false
          },
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: true,
              pan: false,
              reset: false | '<img src="/static/icons/reset.png" width="20">'
            }
          }
        },
        // colors: ["#E91E63", "#2E93fA", "#66BB6A", "#FFA726", "#7E57C2"],
        colors: ["#E91E63", "#42A5F5", "#00C853", "#F57C00", "#7E57C2"],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight",
          width: 2
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.4
          }
        },
        xaxis: {
          categories: [...x]
          // title: {
          //   text: "Date",
          //   style: {
          //     fontSize: "14px",
          //     fontWeight: 600,
          //     cssClass: "subtitle-2"
          //   }
          // }
        },
        yaxis: y
      };
    }
  },
  data: () => ({})
};
</script>

<style></style>
